const WhatsApp = {
  link(phone, text) {
    const msg = encodeURIComponent(text || '');
    const num = phone.replace(/[^\d]/g, '');
    return `https://wa.me/${num}?text=${msg}`;
  }
};
export default WhatsApp;
